import type { Project } from '@cinegrid/core';

const DB_NAME = 'cinegrid-media-v1';
const STORE = 'project';
const DB_VERSION = 2;
const ROW_ID = 'current';

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains('blobs')) {
        db.createObjectStore('blobs', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'id' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error ?? new Error('IndexedDB open failed'));
  });
}

/** Persist timeline/project JSON so dual-monitor tabs share one project. */
export async function saveProjectSnapshot(project: Project): Promise<void> {
  try {
    const db = await openDb();
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).put({ id: ROW_ID, project, savedAt: Date.now() });
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error ?? new Error('project put failed'));
    });
    db.close();
  } catch (err) {
    console.warn('saveProjectSnapshot failed', err);
  }
}

export async function loadProjectSnapshot(): Promise<Project | null> {
  try {
    const db = await openDb();
    const row = await new Promise<{ project: Project } | undefined>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).get(ROW_ID);
      req.onsuccess = () => resolve(req.result as { project: Project } | undefined);
      req.onerror = () => reject(req.error ?? new Error('project get failed'));
    });
    db.close();
    return row?.project ?? null;
  } catch (err) {
    console.warn('loadProjectSnapshot failed', err);
    return null;
  }
}
